import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  click(event) {
    if (event.target.tagName === "A" || event.target.closest("a")) {
      return;
    }

    if (this.urlValue) {
      window.location.href = this.urlValue;
    }
  }
}
